export default "__VITE_ASSET__EunUscY___"